// The overlay canvas sits over live video, so the editor shows transparency as a
// checkerboard rather than a still frame. Dark, because overlays are dark-mode and
// have to stay legible against it.
const DARK = '#17171A'
const LIGHT = '#1E1E22'

export const checkerboard = (squarePx) => ({
  backgroundColor: LIGHT,
  backgroundImage: `
    linear-gradient(45deg, ${DARK} 25%, transparent 25%, transparent 75%, ${DARK} 75%),
    linear-gradient(45deg, ${DARK} 25%, transparent 25%, transparent 75%, ${DARK} 75%)`,
  backgroundSize: `${squarePx * 2}px ${squarePx * 2}px`,
  backgroundPosition: `0 0, ${squarePx}px ${squarePx}px`,
})
